import React from 'react';
import { useQuery } from '@apollo/client/react';
import { MainView, NoAccessView } from '@repo/ui/Views';
import { useAccount } from '@/hooks/useAccount';
import { useParams } from 'react-router';

import SUB_ACCOUNTS_SHOW_Q from '../gql/show.gql';
import UpdateSubAccountForm from '../components/UpdateSubAccountForm';
import DeactivateSubAccount from '../components/DeactivateSubAccount';
import ActivateSubAccount from '../components/ActivateAccount';
import SubAccountReadOnlyView from '../components/SubAccountReadOnlyView';

import RedirectToAccountOverview from '@/features/account_overview/components/RedirectToAccountOverview';
import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';

const SubAccount = () => {
  const account = useAccount();
  const accountId = account.id;
  const params = useParams();
  const { subAccountId } = params;
  const user = useUser();

  const canViewSubAccounts = POLICIES['accounts:show'](user);
  const canUpdateSubAccounts = POLICIES['accounts:update'](user);

  const { loading, data, refetch } = useQuery(SUB_ACCOUNTS_SHOW_Q, {
    variables: {
      id: String(subAccountId),
    },
  });

  return (
    <MainView title={data?.account?.name} description={data?.account?.notes}>
      {!canViewSubAccounts ? (
        <NoAccessView />
      ) : account.parentAccount ? (
        <RedirectToAccountOverview />
      ) : (
        <div className="flex flex-col gap-12">
          {data?.account ? (
            <>
              {canUpdateSubAccounts ? (
                <UpdateSubAccountForm
                  subAccountId={data.account.id}
                  name={data.account.name}
                  notes={data.account.notes}
                  lrn_access={data.account.lrnAccess}
                  sms_access={data.account.smsAccess}
                  mms_access={data.account.mmsAccess}
                  require_ip_api_access={data.account.requireIpApiAccess}
                  require_ip_gql_access={data.account.requireIpGqlAccess}
                  refetch={refetch}
                />
              ) : (
                <SubAccountReadOnlyView name={data.account.name} notes={data.account.notes} />
              )}

              {canUpdateSubAccounts && (
                <>
                  {data?.account?.deactivatedAt ? (
                    <ActivateSubAccount
                      subAccountId={data.account.id}
                      name={data.account.name}
                      accountId={accountId}
                    />
                  ) : (
                    <DeactivateSubAccount
                      subAccountId={data.account.id}
                      name={data.account.name}
                      notes={data.account.notes}
                      loading={loading}
                      accountId={accountId}
                    />
                  )}
                </>
              )}
            </>
          ) : null}
        </div>
      )}
    </MainView>
  );
};

export default SubAccount;
